module.exports = __webpack_public_path__ + "img/img6.c5f7d198.png";